import React from 'react';
import moment from 'moment';
import t from 'react-translate';

import { css } from '@emotion/react';
import { gray5 } from 'styles/global_defaults/colors';
import { MentoringProgram } from 'redux/schemas/models/mentoring-programs';

import NvProgramThumbnail from '../../mentoring-program/nv-program-thumbnail';
import InfoSection from './info-section';

type ProgramDataOverride = {
  name?: string;
  releasedDate?: string | null;
  adminsCount?: number;
};

type CloneSourceProgramInfoProps = {
  sourceProgram: MentoringProgram | null;
  programDataOverride?: ProgramDataOverride;
};

const styleCourseInfo = (columns: number = 2) => css`
  border: 1px solid ${gray5};

  .data {
    display: grid;
    grid-template-columns: repeat(${columns}, 1fr);
    align-items: center;
  }
`;

const CloneSourceProgramInfo = ({ sourceProgram, programDataOverride }: CloneSourceProgramInfoProps) => {
  if (!sourceProgram) return null;

  const name = programDataOverride?.name !== undefined ? programDataOverride.name : sourceProgram.name;
  const releasedDate = programDataOverride?.releasedDate !== undefined
    ? programDataOverride.releasedDate
    : sourceProgram.releasedDate;
  const adminsCount = programDataOverride?.adminsCount !== undefined
    ? programDataOverride.adminsCount
    : sourceProgram.adminsCount;
  const { headerBackground } = sourceProgram;
  const formattedReleasedDate = releasedDate && moment(releasedDate).isValid()
    ? moment(releasedDate).format('L')
    : null;

  const translationBase = t.MENTORING_PROGRAMS.PROGRAM_HEADER_MENU.CLONE.STEPS.STEP_ONE.INFO;

  const sections = [
    {
      title: translationBase.PROGRAM_NAME(),
      content: name,
      showTooltip: true,
      contentMaxWidth: 420,
    },
    {
      title: translationBase.RELEASE_DATE(),
      content: formattedReleasedDate,
    },
    {
      title: translationBase.ADMIN_USERS(),
      content: adminsCount,
    },
  ] as {
    title: string;
    content: React.ReactNode;
    showTooltip?: boolean;
    contentMaxWidth?: number;
  }[];

  return (
    <div
      css={styleCourseInfo(sections?.length)}
      className='bg-gray-7 d-flex px-4 py-2 mb-4'
    >
      <NvProgramThumbnail
        headerBackground={headerBackground}
        width={110}
      />
      <div
        className='data w-100 align-items-center ml-4'
      >
        {sections.map((section) => (
          <InfoSection
            key={section.title}
            title={section.title}
            content={section.content}
            showTooltip={section.showTooltip}
            contentMaxWidth={section.contentMaxWidth}
            showDashIfEmpty
          />
        ))}
      </div>
    </div>
  );
};

export default CloneSourceProgramInfo;
